import React from "react";
import "./styles.scss";

/**
 * Branded fallback UI shown when an ErrorBoundary catches an error.
 * - variant "page": centered full-page message (root / route crashes).
 * - variant "section": inline card for a single widget/section crash.
 */
export default function Fallback({ variant = "page", error, onRetry }) {
  const isDev = process.env.NODE_ENV === "development";

  const goHome = () => {
    window.location.href = "/oneapp/home";
  };

  return (
    <div className={`eb-fallback eb-fallback--${variant}`} role="alert">
      <div className="eb-fallback__inner">
        <div className="eb-fallback__icon" aria-hidden="true">
          !
        </div>
        <p className="eb-fallback__title">Something went wrong</p>
        <p className="eb-fallback__text">
          {variant === "section"
            ? "This section couldn’t be displayed. Please try again."
            : "We hit an unexpected error. You can retry or head back home."}
        </p>

        {isDev && error?.message && (
          <pre className="eb-fallback__detail">{error.message}</pre>
        )}

        <div className="eb-fallback__actions">
          {typeof onRetry === "function" && (
            <button
              type="button"
              className="eb-fallback__btn eb-fallback__btn--primary"
              onClick={onRetry}
            >
              Try again
            </button>
          )}
          {variant !== "section" && (
            <button
              type="button"
              className="eb-fallback__btn eb-fallback__btn--secondary"
              onClick={goHome}
            >
              Go to home
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
